export const modal = {
  wrapper: "fixed inset-0 z-[100] flex items-center justify-center p-6",
  overlay: "fixed inset-0 bg-black/30 backdrop-blur-sm transition-opacity z-[90]",
  container: "relative bg-gray-900 w-full max-w-3xl h-[600px] flex flex-col rounded-lg shadow-xl z-[95]",
  header: {
    wrapper: "flex-none p-4 border-b border-gray-800",
    steps: {
      wrapper: "flex items-center justify-between px-12",
      item: {
        base: "flex items-center space-x-3 text-base",
        number: "flex h-8 w-8 items-center justify-center rounded-full border border-cyan-500/20",
        active: "border-orange-500 text-orange-500",
        completed: "border-green-400 text-green-400",
        inactive: "border-cyan-500/20 text-gray-600",
        title: "text-cyan-100 font-medium"
      }
    }
  },
  content: {
    wrapper: "flex-1 min-h-0 p-8",
    grid: "grid grid-cols-2 gap-12 h-full",
    centered: "flex flex-col items-center justify-center h-full",
    left: {
      wrapper: "flex flex-col justify-center space-y-6 pr-8",
      title: "text-3xl font-bold text-white",
      description: "text-lg text-gray-300 leading-relaxed"
    },
    right: {
      wrapper: "flex flex-col justify-center space-y-8",
      form: "space-y-6"
    }
  },
  footer: {
    wrapper: "flex-none p-4 border-t border-gray-800",
    content: "flex",
    button: {
      base: "px-6 py-2.5 text-sm font-medium rounded-lg transition-colors duration-200",
      enabled: "bg-gradient-to-r from-cyan-500 to-blue-500 text-white hover:from-cyan-600 hover:to-blue-600",
      disabled: "bg-gray-800 text-gray-500 cursor-not-allowed",
      secondary: "bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white"
    }
  },
  components: {
    progress: {
      circular: {
        wrapper: "relative flex items-center justify-center w-48 h-48",
        svg: "w-full h-full -rotate-90 transform",
        backgroundCircle: "stroke-cyan-900/20",
        progressCircle: "stroke-cyan-500 transition-all duration-300",
        text: "absolute text-2xl font-medium text-cyan-400"
      },
      status: {
        wrapper: "mt-4 text-center",
        text: "text-sm text-cyan-400/70"
      }
    },
    upload: {
      status: {
        wrapper: "mt-4",
        progress: {
          wrapper: "flex flex-col items-center",
          text: "text-sm text-cyan-400/70 mb-2",
          bar: {
            wrapper: "w-64 h-1 bg-gray-800 rounded-full overflow-hidden",
            fill: "h-full bg-gradient-to-r from-cyan-500 to-blue-500 transition-all duration-300"
          }
        },
        error: {
          wrapper: "mt-2 text-center",
          message: "text-sm text-red-400"
        }
      }
    }
  }
} 